// @flow
import { path } from 'ramda'

import { getMoviesCategories } from '@alphaott/api-client'
import { getPublicDomain, getCacheChannels, isCacheValid } from '@alphaott/app-main/selectors'

export const FETCH_MOVIE_CATEGORIES_TYPE = 'movies_categories/FETCH_CATEGORIES'

const fetchMovieCategoriesAction = (servicespec: string) => (dispatch: Function, getState: Function) => {
  const state = getState()
  const publicApi = getPublicDomain(state)
  const ttl = getCacheChannels(state)

  return dispatch({
    type: FETCH_MOVIE_CATEGORIES_TYPE,
    payload: getMoviesCategories(publicApi, servicespec),
    meta: { ttl },
  })
}

// eslint-disable-next-line complexity
export const fetchMovieCategories = (servicespec: string, force: ?boolean = false) => (
  dispatch: Function,
  getState: Function,
) => {
  if (force) return dispatch(fetchMovieCategoriesAction(servicespec))

  const state = getState()
  const expires = path(['movieCategories', 'expires'], state)

  if (expires && isCacheValid(expires)) return null

  return dispatch(fetchMovieCategoriesAction(servicespec))
}
